import cx from 'classnames'
import Styles from '../PropertyForm.module.scss'

const Document = () => {
  return <div className={cx(Styles.sectionSubheader, Styles.defaultInputWrapper)}>Add a Blaze doc as a property.</div>
}

export default Document
